export default {"src":"/_next/static/media/Fansly.e8735c1d.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};